import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import './acciones.css';
import Swal from 'sweetalert2';


class Acciones extends Component {
    constructor(props) {
        super(props);
    }

    eliminar = (id) => {
        return () => {
            Swal.fire({
                title: '¿Eliminar?',
                text: '¡No podrá revertir esta acción!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: '¡Sí, eliminar!',
                cancelButtonText: 'No, cancelar',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.props.eliminar(id);
                }
            });
        }
    };

    eliminarCuentaContable = (id, numero_cuenta) => {
        return () => {
            Swal.fire({
                title: '¿Eliminar cuenta contable: \n'
                    + numero_cuenta + '?',
                text: '¡No podrá revertir esta acción!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: '¡Sí, eliminar!',
                cancelButtonText: 'No, cancelar',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.props.eliminarCuentaContable(id);
                }
            });
        }
    };

    render() {
        const { id, ver, editar, eliminar, eliminarCuentaContable, numero_cuenta } = this.props;

        return (
            <div className="d-flex justify-content-center">
                {(ver !== undefined) && (
                    <Link style={{color: "white"}} to={`${ver}/${id}/`} className="px-2" ><i className="material-icons">remove_red_eye</i></Link>
                )}
                {(editar !== undefined) && (
                    <Link style={{color: "white"}} to={`${editar}/${id}/editar`} ><i className="material-icons">edit</i></Link>
                )}
                {(eliminar !== undefined) && (
                    <a className="px-2" style={{cursor: "pointer", color: "white"}} onClick={this.eliminar(id)}><i className="material-icons">delete</i></a>
                )}
                {(eliminarCuentaContable !== undefined) && (
                    <a className="px-2" style={{cursor: "pointer", color: "white"}} onClick={this.eliminarCuentaContable(id, numero_cuenta)}><i className="material-icons">delete</i></a>
                )}
            </div>
        );
    }
}
Acciones.propTypes = {
};

export function standardActions(acciones) {
    return (cell, row) => {
        return ( <Acciones id={cell} numero_cuenta={row.numeroCuenta}
            {...acciones}/> )
    };
}
